'use strict';

var TRANSFORM_VARIANTS = {
  'WebkitTransform': '-webkit-transform',
  'transform': 'transform'
};

function test() {
  if (typeof document === 'undefined') {
    console.log('document unavailable in node');
    return;
  }
  var testEl = document.createElement('div'),
      style = testEl.style;

  for (let [jsProp, cssProp] of Object.entries(TRANSFORM_VARIANTS)) {
    style.cssText = `${cssProp}: translate3d(0, 0, 0)`;

    if (style[jsProp] && style[jsProp].length) {
      return {
        js: jsProp,
        css: cssProp
      };
    }
  }
}

var property;
function getSupportedTransformProperty() {
  if (!property) {
    property = test();
  }

  return property;
}

module.exports = getSupportedTransformProperty;



/** WEBPACK FOOTER **
 ** ./utils/getSupportedTransformProperty.js
 **/